import JsEvent from '@rotomeca/event';
import BnumElement from 'components/bnum-element';

export function OnLinkedClickEventInitializer(
  event: JsEvent<(click: string) => void>,
  instance: BnumElement,
) {
  instance.addEventListener('click', () => {
    event.call();
  });
}
